import styled from 'styled-components';

import { TranslatableText } from '@dreryk/react-common';
import { TestableComponentProps, TextView } from '@dreryk/react-components';

const StyledTextView = styled(TextView)`
   flex: 1;
`;

type ExistingPatientFormComparedPatientTextViewProps = TestableComponentProps & {
   readonly value: string | undefined;
   readonly label: TranslatableText;
};

export const ExistingPatientFormComparedPatientTextView = (
   props: ExistingPatientFormComparedPatientTextViewProps
): JSX.Element => {
   return (
      <StyledTextView testId={props.testId} label={props.label}>
         {props.value ?? '-'}
      </StyledTextView>
   );
};
